// MUTATIONS
export const MUTATION_SET_AVAILABLE_REGIONS                    = 'setAvaukabkeRegions'
export const MUTATION_SET_TAXONOMIC_REGION                    = 'setTaxonomicRegion'
export const MUTATION_SET_TAXON                    = 'setCurrentTaxon'
export const MUTATION_SET_TAXON_CRITERIA                    = 'setCurrentTaxonCriteria'

// ACTIONS
export const ACTION_LOAD_AVAILABLE_REGIONS                    = 'loadAvailableRegions'
export const ACTION_LOAD_TAXON_CRITERIA                    = 'loadCurrentTaxonCriteria'
